import React, { useEffect } from 'react';
import '../styles/TeamExpertiseSection.css' ;

const TeamExpertiseSection = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const delay = parseInt(element.dataset.delay) || 0;
          
          setTimeout(() => {
            if (element.classList.contains('team-expertise-card')) {
              element.classList.add('team-expertise-animate-in');
            } else if (element.classList.contains('team-expertise-stat-item')) {
              element.classList.add('team-expertise-animate-in');
              animateCounter(element);
            }
          }, delay);
          
          observer.unobserve(element);
        }
      });
    }, observerOptions);

    // Observe team expertise cards
    document.querySelectorAll('.team-expertise-card').forEach(card => {
      observer.observe(card);
    });

    // Observe stat items
    document.querySelectorAll('.team-expertise-stat-item').forEach(item => {
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  const animateCounter = (element) => {
    const numberElement = element.querySelector('.team-expertise-stat-number');
    if (!numberElement) return;
    
    const target = parseInt(numberElement.dataset.target);
    const duration = 2000;
    const startTime = Date.now();
    
    const updateCounter = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const current = Math.floor(progress * target);
      
      numberElement.textContent = current.toLocaleString();
      
      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      } else {
        numberElement.textContent = target.toLocaleString();
      }
    };
    
    updateCounter();
  };

  return (
    <section className="team-expertise-section">
      <div className="team-expertise-container">
        {/* Hero Section */}
        <div className="team-expertise-hero">
          <h2 className="team-expertise-title">The Team Behind 17,500+ Daily Meals</h2>
          <p className="team-expertise-subtitle">Professional excellence across India's industrial landscape</p>
        </div>

        {/* Features Grid */}
        <div className="team-expertise-grid">
          <div className="team-expertise-card" data-delay="0">
            <div className="team-expertise-icon">🏭</div>
            <h3 className="team-expertise-card-title">Professional Excellence Across Industries</h3>
            <p className="team-expertise-card-description">
              Our experienced team manages industrial catering operations across 5 states, serving everyone from renewable energy pioneers to pharmaceutical manufacturers. Deep industry knowledge ensures consistent quality whether serving 30 or 2,000+ employees.
            </p>
          </div>
          
          <div className="team-expertise-card" data-delay="100">
            <div className="team-expertise-icon">🎯</div>
            <h3 className="team-expertise-card-title">Strategic Leadership & Local Expertise</h3>
            <p className="team-expertise-card-description">
              Led by seasoned professionals with over 15 years in industrial catering, our team combines strategic vision with hands-on operational knowledge. Each member brings specialized expertise in large-scale food preparation and client relations.
            </p>
          </div>

          <div className="team-expertise-card" data-delay="200">
            <div className="team-expertise-icon">⭐</div>
            <h3 className="team-expertise-card-title">Values-Driven Service Delivery</h3>
            <p className="team-expertise-card-description">
              Our team operates with unwavering commitment to Quality, Service, Integrity, and Trust. This values-driven approach has helped us maintain long-term partnerships - some clients have been with us since 2009.
            </p>
          </div>

          <div className="team-expertise-card" data-delay="300">
            <div className="team-expertise-icon">🔗</div>
            <h3 className="team-expertise-card-title">Scalable Operations Network</h3>
            <p className="team-expertise-card-description">
              From our first client in Dindori to serving 25+ locations nationwide, our team has built scalable systems and processes. We understand complex industrial environments and shift patterns.
            </p>
          </div>

          <div className="team-expertise-card" data-delay="400">
            <div className="team-expertise-icon">📈</div>
            <h3 className="team-expertise-card-title">Continuous Growth & Innovation</h3>
            <p className="team-expertise-card-description">
              Our team's commitment to excellence drives continuous improvement. We regularly update service models, expand capabilities, and invest in new technologies to better serve our growing client base.
            </p>
          </div>

          <div className="team-expertise-card" data-delay="500">
            <div className="team-expertise-icon">🕒</div>
            <h3 className="team-expertise-card-title">24/7 Commitment to Excellence</h3>
            <p className="team-expertise-card-description">
              With team members strategically positioned across service areas, we provide round-the-clock support and rapid response capabilities, ensuring industrial clients never face disruptions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamExpertiseSection;